import { makeOptionallyAuthenticatedQuery } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'
import type { AutocompleteResponse } from '@b-stock/search-api-client'

import getAllListingsSearchClient from './getAllListingsSearchClient'

type AutocompleteParams = {
  query: string
  queryModel?: string
}

const getAutocompleteData = async (
  _accessToken: string | null,
  { query, queryModel }: AutocompleteParams
): Promise<AutocompleteResponse> => {
  try {
    const searchClient = getAllListingsSearchClient()
    const axiosParams = buildAxiosRequestConfig({ accessToken: _accessToken })

    // Type assertion needed because the auto-generated API client incorrectly types
    // allListingsAutocomplete as returning void instead of AutocompleteResponse
    const response = (await searchClient.allListingsAutocomplete(
      {
        query,
        queryModel,
      },
      axiosParams
    )) as unknown as { data: AutocompleteResponse }

    return response.data
  } catch (_error) {
    // Fail gracefully - return empty suggestions instead of throwing
    return { querySuggestions: [] }
  }
}

const autocompleteQuery = makeOptionallyAuthenticatedQuery<
  [AutocompleteParams],
  AutocompleteResponse
>('autocomplete', getAutocompleteData, {
  staleTime: 5 * 60 * 1000, // 5 minutes
})

export default autocompleteQuery
